import { PropsWithChildren } from 'react';

import Link from './Link';

export const SERVICES_EMAIL = 'services@healthdata.org';
export const SERVICES_MAILTO = `mailto:${SERVICES_EMAIL}`;

const ServicesLink = ({ children }: PropsWithChildren) => (
    <Link href={SERVICES_MAILTO} style={{ display: 'inline' }}>
        {children || SERVICES_EMAIL}
    </Link>
);

export default ServicesLink;
